import axios from 'axios';

const url_server = 'https://us-central1-website-alavtutti.cloudfunctions.net/app';

export const postValuesForm = (userData) => {
  axios.post(url_server + '/sendEmail', userData)
    .then(response => response.json())
    .catch(error => console.error(error));
}
